import {
  AttrField,
  BelongsToField,
  BooleanField,
  HasManyByField,
  NumberField,
  OrmModel,
  StringField,
} from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'
import EmailCampaignMessage from '@/data/models/domain/campaign/EmailCampaignMessage'
import FollowUpDetails from '@/data/models/domain/FollowUpDetails'
import FollowUp from '@/data/models/domain/FollowUp'
import Label from '@/data/models/domain/Label'
import { TmArrayStringField } from '@/data/utils/types'

export enum EmailCampaignStatus {
  Sent = 'sent',
  Failed = 'failed',
  Delivered = 'delivered',
  Rejected = 'rejected',
  Error = 'error',
  InProgress = 'in_progress',
  ScheduledError = 'scheduledError',
}

export type EmailCampaignTotals = {
  bounced: number
  failed: number
  clicked: number
  delivered: number
  opened: number
  recipients: number
  rejected: number
  spamReports: number
  unsubscribed: number
}

@OrmModel(modelNames.EMAIL_CAMPAIGN)
export default class EmailCampaign<
  T extends EmailCampaignStatus = EmailCampaignStatus,
  TWithEmail extends boolean = boolean,
  TBulk extends boolean = boolean,
> extends BaseModel {
  /**
   * @deprecated - will be removed
   */
  @StringField()
  public title: string

  @StringField()
  public subject: string

  @StringField()
  public html: string

  @StringField()
  public startAt: string

  @StringField()
  public status: T

  @StringField()
  public fromName: string

  @StringField()
  public fromEmail: string

  @StringField()
  public replyToEmail: string

  @NumberField()
  public cost: number

  @BooleanField()
  public isSentUsingBonus: boolean

  @NumberField()
  public emailSenderId: number

  @StringField()
  public createdById: string

  @StringField(null)
  public createdByAutomationId: string | null

  @AttrField()
  public totals: EmailCampaignTotals

  @AttrField()
  public outboundEmailId: TWithEmail extends true ? string : null

  @BelongsToField(EmailCampaignMessage, 'outboundEmailId')
  public outboundEmail: TWithEmail extends true ? EmailCampaignMessage : null

  @StringField()
  public followUpDetailsId: string

  @BelongsToField(FollowUpDetails, 'followUpDetailsId')
  public followUpDetails: FollowUpDetails | null

  @StringField()
  public followUpId: string
  /**
   * Use {@link relatedFollowUp}
   */

  @BelongsToField(FollowUp, 'followUpId')
  public followUp: FollowUp | null

  @TmArrayStringField()
  public labelIds: string[]

  @HasManyByField(Label, 'labelIds')
  public labels: Label[]

  public get relatedFollowUp() {
    return this.followUp
  }

  public get isBulk() {
    return (this.totals.recipients > 1) as TBulk
  }

  public get isSending() {
    return this.status === EmailCampaignStatus.InProgress && this.isBulk
  }
}
